import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="bg-cream pt-6 pb-8 px-4 md:px-8 overflow-hidden" data-id="element-88">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-89">
        <FadeIn data-id="element-90">
          <h1 className="text-2xl md:text-3xl font-bold text-forest mb-2 leading-tight" data-id="element-91">
            The 10-Minute Anti-Inflammatory Ritual for Women Over 60
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-92">
          <p className="text-base md:text-lg font-medium text-charcoal mb-3 max-w-2xl" data-id="element-93">
            Reduce stiffness, ease joint pain, and feel more energized — without
            complicated cooking
          </p>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-94">
          <p className="text-sm md:text-base text-gray-700 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-95">
            A simple daily system combining quick anti-inflammatory recipes and
            easy habits to help your body feel better every morning.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="w-full max-w-md mx-auto mb-6" data-id="element-96">
          <div className="relative rounded-xl overflow-hidden shadow-xl" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/abWjdQcvy5Qp2bFZtuoR2f/MockupEbook10MinuteNew.png" alt="The 10-Minute Anti-Inflammatory Ritual for Women Over 60 Ebook" className="w-full h-auto object-cover" data-id="element-98" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col items-center w-full max-w-sm mx-auto" data-id="element-99">
          <Button href="#offer" className="w-full mb-2" data-id="element-100">
            GET THE 10-MINUTE PROTOCOL NOW
          </Button>
          <p className="text-xs text-gray-500 flex items-center justify-center gap-1.5" data-id="element-101">
            <svg className="w-3.5 h-3.5 text-forest" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-102">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-103" />
            </svg>
            Safe & Secure Digital Delivery. Access your guide immediately after
            purchase.
          </p>
        </FadeIn>
      </div>
    </section>;
}